import state from './moduleProfessionalProfilesState'
import mutations from './moduleProfessionalProfilesMutations'
import actions from './moduleProfessionalProfilesActions'
import getters from './moduleProfessionalProfilesGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}